import type { ClientImages } from '../../typings/brands'

const images: ClientImages = {
  logo: `/commercial/p66/header-logo.png`,
  brandLogo: '/p66/commercial/transaction-logo.png',
  loginHeaderCardsImage: '/commercial/p66/login_header_cards.png',
  proxCard: '',
  brcCard: '/commercial/p66/brc_card.png',
  dcCard: '',
  banner: {
    desktop: '',
    mobile: ''
  },
  plccBanner: {
    desktop: '',
    mobile: ''
  },
  monthlyStatement: '/commercial/monthly_statement.png',
  welcomeLetter: '/commercial/welcome_letter.png'
}

export default images
